import { buildSurveyScript } from "./buildSurveyScript";

export const createSurveyScriptUrl = (identifier?: string, domain?: string): { url: string; revoke: () => void } => {
  const script = buildSurveyScript({ identifier, domain });

  if (!script) {
    throw new Error("Invalid identifier or domain for survey script.");
  }

  const blob = new Blob([script], { type: "text/html" });
  const url = URL.createObjectURL(blob);

  return {
    url,
    revoke: () => URL.revokeObjectURL(url),
  };
};
